import { SYMPTOM_CODE } from 'lib/symptom-checker';

export const questionNumber: Record<SYMPTOM_CODE, number> = {
  [SYMPTOM_CODE.SELECT_BODY_PART]: 1,
  [SYMPTOM_CODE.OTHER_BODY_PART]: 1,
  [SYMPTOM_CODE.FEEL_SYMPTOMS]: 2,
  [SYMPTOM_CODE.PAIN_LEVEL]: 3,
  [SYMPTOM_CODE.SYMPTOMS_DURATION]: 4,
  [SYMPTOM_CODE.OTHER_SYMPTOMS]: 5,
  [SYMPTOM_CODE.STARTED_MEDICATION]: 6,
  [SYMPTOM_CODE.IMAGE_UPLOAD]: 7,
  [SYMPTOM_CODE.ADDITIONAL_DETAIL]: 8,
  [SYMPTOM_CODE.CONFIRMATION]: 10,
};
